// One-off cleanup of what web offline mode left in browsers (unified
// navigation spec §7). Safe to run on every boot: each step is a no-op once
// done. Remove after one release cycle together with the retire workers.

export const LEGACY_OFFLINE_DB = "control-offline";
const LEGACY_KEYS = ["control.offline.outbox_owner", "control.offline.last_seed_at"];

export function dropLegacyOfflineData(
  idb: IDBFactory | undefined = typeof indexedDB === "undefined" ? undefined : indexedDB,
  storage: Storage | undefined = typeof localStorage === "undefined" ? undefined : localStorage,
): Promise<void> {
  LEGACY_KEYS.forEach((k) => storage?.removeItem(k));
  if (!idb) return Promise.resolve();
  return new Promise((resolve) => {
    const req = idb.deleteDatabase(LEGACY_OFFLINE_DB);
    const done = () => resolve();
    req.onsuccess = done;
    req.onerror = done;
    // Another tab still has it open; the delete completes once that closes.
    req.onblocked = done;
  });
}

export async function retireServiceWorkers(
  container: ServiceWorkerContainer | undefined =
    typeof navigator !== "undefined" && "serviceWorker" in navigator ? navigator.serviceWorker : undefined,
): Promise<number> {
  if (!container) return 0;
  const regs = await container.getRegistrations();
  await Promise.all(regs.map((r) => r.unregister()));
  return regs.length;
}
